<template>
    <div class="NoDataSkeleton">
        <img src="../../assets/img/svg/activities.svg">
        <h3 class="NoDataSkeleton-title">New activities coming soon!</h3>
        <!--<p class="NoDataSkeleton-info">Notify you by email when activities appear?</p>-->
       <!-- <switch-button switch-text="YES/NO"/>-->
    </div>
</template>

<script>
    export default {
        name: 'NoDataSkeleton',

        components: {
            SwitchButton: () => import('@/components/controls/SwitchButton'),
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .NoDataSkeleton{
        position: relative;
        right: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 15%;

        @media screen and (max-width: 900px) {
            position: static;
            margin-top: 10px;
        }

        img {
            width: 83px;
            height: 83px;
            opacity: 0.2;
        }

        &-title {
            margin-top: 43px;
            font-size: 30px;
            font-weight: 700;
            line-height: 1.33;
            text-align: center;
            color: $ControlsGrey;

            @media screen and (max-width: 900px) {
                margin-top: 20px;
            }
        }

        &-description {
            font-weight: 400;
            font-size: 18px;
            line-height: 1.44;
            text-align: center;
            color: $ControlsGrey;
            max-width: 509px;

            @media screen and (max-width: 600px) {
                display: none;
            }
        }

        &-info {
            margin-bottom: 30px;
            font-weight: 400;
            font-size: 16px;
            color: $WhiteGrey;

            @media screen and (max-width: 600px) {
                margin-bottom: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/NoDataSkeleton.vue